import Cookies from "js-cookie";
import { C24AppVersionParser } from "@infrastructure/Helpers/NativeAppVersionParser";

export const getNativeAppVersion = () => {
    const appVersion = Cookies.get("c24appversion");
    if (!appVersion) {
        return undefined;
    }
    return C24AppVersionParser.parseC24AppVersion(appVersion);
};
